import { FETCH_FISCALYEAR, FETCH_FISCALYEAR_SUCCESS, FETCH_FISCALYEAR_FAILURE, CHANGE_FISCALYEAR } from '../actions/FiscalYear'

const initialState = {
  list: null,
  current: null,
  error: null,
  loading: false
}

export default function fiscalyear (state = initialState, action) {
  switch (action.type) {
    case FETCH_FISCALYEAR:
      return {...state, loading: true, error: null, info: null}
    case FETCH_FISCALYEAR_SUCCESS:
      window.localStorage.setItem('it.clubhub.fiscalyear', parseInt(action.payload[0].id, 10))
      return {...state, list: action.payload, current: parseInt(action.payload[0].id, 10), loading: false, error: null}
    case FETCH_FISCALYEAR_FAILURE:
      return {...state, error: action.payload, current: null, loading: false, list: null}
    case CHANGE_FISCALYEAR:
      window.localStorage.setItem('it.clubhub.fiscalyear', parseInt(action.payload, 10))
      return {...state, current: parseInt(action.payload, 10)}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fiscalyear.js